(function () {
  const POSTER_VARIANT_ID = 66858708762669;
  const STICKER_SHEET_VARIANT_ID = 66962880233517;
  const POSTER_THRESHOLD_CENTS = 15000;

  let isUpdating = false;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addItem(variantId) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
  }

  async function removeItem(cart, variantId) {
    const item = cart.items.find(item => item.variant_id === variantId);
    if (!item) return;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
  }

  function hasItem(cart, variantId) {
    return cart.items.some(item => item.variant_id === variantId);
  }

  function subtotalWithoutGifts(cart) {
    return cart.items.reduce((total, item) => {
      if (
        item.variant_id === POSTER_VARIANT_ID ||
        item.variant_id === STICKER_SHEET_VARIANT_ID
      ) {
        return total;
      }

      return total + item.final_line_price;
    }, 0);
  }

  async function updateFreeGifts() {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const cart = await getCart();

      const subtotal = subtotalWithoutGifts(cart);
      const hasPoster = hasItem(cart, POSTER_VARIANT_ID);
      const hasStickerSheet = hasItem(cart, STICKER_SHEET_VARIANT_ID);

      const hasPaidItems = cart.items.some(item =>
        item.variant_id !== POSTER_VARIANT_ID &&
        item.variant_id !== STICKER_SHEET_VARIANT_ID
      );

      let changed = false;

      if (hasPaidItems && !hasStickerSheet) {
        await addItem(STICKER_SHEET_VARIANT_ID);
        changed = true;
      }

      if (!hasPaidItems && hasStickerSheet) {
        await removeItem(cart, STICKER_SHEET_VARIANT_ID);
        changed = true;
      }

      if (subtotal >= POSTER_THRESHOLD_CENTS && !hasPoster) {
        await addItem(POSTER_VARIANT_ID);
        changed = true;
      }

      if (subtotal < POSTER_THRESHOLD_CENTS && hasPoster) {
        await removeItem(cart, POSTER_VARIANT_ID);
        changed = true;
      }

      if (changed) {
        window.location.reload();
      }
    } catch (err) {
      console.error('Free gifts error:', err);
    }

    isUpdating = false;
  }

  document.addEventListener('DOMContentLoaded', updateFreeGifts);
  document.addEventListener('click', () => setTimeout(updateFreeGifts, 800));
  document.addEventListener('change', () => setTimeout(updateFreeGifts, 800));
})();